"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  en: {
    shoppingLists: {
      actions: {
        insert: 'Add to Cart',
        rename: 'Rename'
      },
      shoppingListsDialog: {
        title: 'My Shopping Lists'
      },
      saveShoppingListDialog: {
        title: 'Save shopping list with name',
        shoppingListName: {
          label: 'List Name',
          helperText: 'Give name of the shopping list. By this name will be list later identified. The name can be changed later.',
          helperTextPreview: ''
        }
      },
      shoppingListItemCollapsed: {
        quantity: 'pcs'
      }
    }
  }
};
var _default = messages;
exports.default = _default;